export default (address, residentialAddress, siteName) => ({
  addressId: '',
  addressee: residentialAddress.addressee,
  companyName: siteName,
  houseNameNumber: siteName,
  streetName: address.streetName,
  addressLine2: address.line_1,
  town: address.city,
  county: address.region,
  postCode: address.postcode,
  countryCode: address.countryCode,
  residentId: residentialAddress.residentId,
  contactNumber: address.contactNumber,
  clickAndCollectType: 'STORE',
});
